import { Pie } from '@ant-design/plots';
import { useTranslation } from 'react-i18next';
import { IconBook, IconLeft } from './Icon';
import { Spin } from 'antd';
import { useMemo } from 'react';

const OverView = ({ consent, isLoading }) => {
    const { t } = useTranslation();
    const config = useMemo(() => {
        return {
            data: [
                {
                    type: t('releasedConsent'),
                    value: consent.consentPublished,
                    total:
                        Number(consent.consentPublished) +
                        Number(consent.consentDraft),
                },
                {
                    type: t('unreleasedConsent'),
                    value: consent.consentDraft,
                    total:
                        Number(consent.consentPublished) +
                        Number(consent.consentDraft),
                },
            ],
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => {
                switch (type) {
                    case t('unreleasedConsent'):
                        return '#D0AEFF';
                    default:
                        return '#7B67FB';
                }
            },
            radius: 1,
            width: 159,
            height: 150,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: false,
        };
    }, [consent, t]);

    return (
        <div>
            <Spin spinning={isLoading}>
                <div className="bg-white rounded-lg grid grid-cols-2 p-12 relative">
                    <div className="absolute top-16">
                        <IconLeft />
                    </div>
                    <div>
                        <div className="text-[60px] font-semibold">
                            {consent?.totalIdentity || 0}
                        </div>
                        <div>
                            <div className="text-xl font-semibold">
                                {t('Total Identity')}
                            </div>
                            <div className="text-base text-[#808191]">
                                {t(
                                    'The number of individuals who accepted the consent request'
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-end">
                        <IconBook />
                    </div>
                </div>
            </Spin>
            <Spin spinning={isLoading}>
                <div className="px-12 py-6 mt-6 bg-white rounded-lg">
                    <div className="text-xl font-semibold Total Consent">
                        {t('Total Consent')}
                    </div>
                    <div className="flex items-center mt-4">
                        <Pie {...config} />
                        <div className="text-tiny space-y-3 ml-auto">
                            <div className="flex justify-between items-center space-x-4">
                                <div className="flex items-center space-x-2">
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6"
                                            r="6"
                                            fill="#7B67FB"
                                        />
                                    </svg>
                                    <span>
                                        {t('Number of consents published')}
                                    </span>
                                </div>
                                <div className="text-[#808191] text-right">
                                    {consent?.consentPublished || 0} (
                                    {consent?.consentPublished
                                        ? (
                                              (Number(
                                                  consent.consentPublished
                                              ) /
                                                  (Number(
                                                      consent.consentPublished
                                                  ) +
                                                      Number(
                                                          consent.consentDraft
                                                      ))) *
                                              100
                                          ).toFixed(2)
                                        : '00.00'}
                                    %)
                                </div>
                            </div>
                            <div className="flex justify-between items-center space-x-4">
                                <div className="flex items-center space-x-2">
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="6"
                                            cy="6"
                                            r="6"
                                            fill="#D0AEFF"
                                        />
                                    </svg>
                                    <span>
                                        {t('Number of unpublished consent')}
                                    </span>
                                </div>
                                <div className="text-[#808191] text-right">
                                    {consent?.consentDraft || 0} (
                                    {consent?.consentDraft
                                        ? (
                                              (Number(consent.consentDraft) /
                                                  (Number(
                                                      consent.consentPublished
                                                  ) +
                                                      Number(
                                                          consent.consentDraft
                                                      ))) *
                                              100
                                          ).toFixed(2)
                                        : '00.00'}
                                    %)
                                </div>
                            </div>
                            <div
                                className="flex justify-between items-center space-x-4 pt-2"
                                style={{ borderTop: '0.5px solid #95A0A8' }}
                            >
                                <div className="font-semibold">
                                    {t('Total number of consents')}
                                </div>
                                <div className="text-[#808191] text-right">
                                    {Number(consent.consentPublished) +
                                        Number(consent.consentDraft) ?? 0}{' '}
                                    (100%)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default OverView;
